import type { SxProps, Theme } from "@mui/material/styles"

export const resultItemSelectedSx: SxProps<Theme> = {
  "&.Mui-selected": { backgroundColor: "#F1F8FF" },
  "&.Mui-selected:hover": { backgroundColor: "#F1F8FF" },
  "&:hover": { backgroundColor: "#F1F8FF" },
}

export const managerAvatarGroupSx: SxProps<Theme> = {
  "& .MuiAvatar-root": {
    width: 28,
    height: 28,
    bgcolor: "#77A3CA",
    color: "#FFF",
    fontSize: "12px",
    fontWeight: 400,
    lineHeight: "12px",
    borderRadius: "100px",
    border: "none",
    ml: 0.25,
  },
  "& .MuiAvatar-root:first-of-type": {
    ml: 0.25,
  },
}
